var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.095,
    height: 15.099,
    viewBox: "0 0 15.095 15.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M19.418,18.5l-4.2-4.237a5.983,5.983,0,1,0-.908.92l4.171,4.21a.646.646,0,0,0,.912.024A.65.65,0,0,0,19.418,18.5Zm-8.9-3.267a4.724,4.724,0,1,1,3.341-1.384A4.695,4.695,0,0,1,10.518,15.232Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#80838e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3a414ee1db51438eee7e0db8b0c91f54.svg";
export { ForwardRef as ReactComponent };